import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const FolderIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M6.32069 2.36526H3.75C2.23122 2.36526 1 3.59648 1 5.11526V11.6153C1 13.1341 2.23122 14.3653 3.75 14.3653H12.25C13.7688 14.3653 15 13.1341 15 11.6153V7.11526C15 5.59648 13.7688 4.36526 12.25 4.36526H9.07931C9.01078 4.36526 8.94526 4.33713 8.89806 4.28745L7.58944 2.90995C7.25905 2.56217 6.80038 2.36526 6.32069 2.36526Z"
		/>
	</svg>
))
